import { searchCondition, saveCondition, deleteCondition } from '@/apis/search-favorite';
import { SEARCH_FAVORITE } from '../mutation-types';

export const state = {
  conditions: []
};

export const getters = {
  conditions: state => state.conditions
};

export const mutations = {
  [SEARCH_FAVORITE.SEARCH_CONDITION](state, data) {
    if (!data.error) {
      state.conditions = data;
    }
  },
  [SEARCH_FAVORITE.SAVE_CONDITION](state, data) {
    const condition = state.conditions.find((item) => item.id === data.u_favourite_search_id);
    condition.receive_mail_flag = !condition.receive_mail_flag;
  },
  [SEARCH_FAVORITE.DELETE_CONDITION](state, data) {
    const condition = state.conditions.find((item) => item.id === data.u_favourite_search_id);
    state.conditions.splice(condition, 1);
  }
};

export const actions = {
  async searchCondition({ commit }) {
    const res = await searchCondition();
    commit(SEARCH_FAVORITE.SEARCH_CONDITION, res);
    return res;
  },

  async saveCondition({ commit }, payload) {
    const res = await saveCondition(payload);
    if (res.error) {
      return res;
    }
    const data = {
      u_favourite_search_id: payload.u_favourite_search_id
    };
    commit(SEARCH_FAVORITE.SAVE_CONDITION, data);
    return false;
  },

  async deleteCondition({ commit }, payload) {
    const res = await deleteCondition(payload);
    if (res.error) {
      return res;
    }
    commit(SEARCH_FAVORITE.DELETE_CONDITION, payload);
    return false;
  }
};
